module.exports = __webpack_public_path__ + "media/images/Heart-24d8fc6782b1838167d13fb7dd44453f.svg";